<!-- Email tab: Emails | Broadcasts switch, search, actions; then an inbox-style list -->
<div class="em">

  <div class="em-toolbar">
    <div class="em-switch" role="tablist" aria-label="Messages">
      <button type="button" role="tab" class="em-switch__btn" [class.is-active]="showEmail"
        [attr.aria-selected]="showEmail" (click)="showList('email')">
        <mat-icon>mail_outline</mat-icon>Emails
        <span class="em-switch__count">{{ All3CEmailList?.length || 0 }}</span>
      </button>
      <button type="button" role="tab" class="em-switch__btn" [class.is-active]="showBroadCast"
        [attr.aria-selected]="showBroadCast" (click)="showList('broadcast')">
        <mat-icon>campaign</mat-icon>Broadcasts
        <span class="em-switch__count" *ngIf="showBroadCast">{{ All3CBroadCastList?.length || 0 }}</span>
      </button>
    </div>

    <div class="em-search">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="emailSearch"
        [placeholder]="showBroadCast ? 'Search broadcasts' : 'Search subject or recipient'" aria-label="Search">
      <button type="button" class="em-search__clear" *ngIf="emailSearch" (click)="emailSearch = ''" aria-label="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="em-actions">
      <button mat-stroked-button class="em-btn" (click)="openWelcomeEmail()">
        <mat-icon>mark_email_read</mat-icon> Welcome Email
      </button>
      <button mat-flat-button class="em-btn em-btn--primary" (click)="addEmailAction()">
        <mat-icon>add</mat-icon> Create Email
      </button>
    </div>
  </div>

  <!-- shared status pill -->
  <ng-template #emStatus let-data>
    <span class="em-status" [ngClass]="'is-' + (data.senmessage || '').toLowerCase()">
      <i></i>{{ data.senmessage }}<ng-container *ngIf="data.senmessage == 'Opened' && data.readCount"> · {{ data.readCount }}</ng-container>
    </span>
  </ng-template>

  <!-- ===== Emails ===== -->
  <ng-container *ngIf="showEmail">
    <div class="em-list" *ngIf="filteredEmails.length; else noEmails">
      <ng-container *ngFor="let group of emailGroups; let gi = index">
      <div class="em-group">{{ group.label }}<span>{{ group.items.length }}</span></div>
      <mat-accordion multi>
        <mat-expansion-panel class="em-item" *ngFor="let data of group.items; let i = index; trackBy: trackRow"
          [expanded]="gi === 0 && i === 0">
          <mat-expansion-panel-header>
            <div class="em-row">
              <span class="em-avatar" [ngClass]="'is-' + recipientTone(data.toRecipients)"
                [matTooltip]="data.toRecipients" matTooltipClass="tooltip">{{ recipientInitials(data.toRecipients) }}</span>
              <div class="em-row__text">
                <span class="em-row__line">
                  <span class="em-row__subject">{{ data.subject }}</span>
                  <span class="em-row__preview" *ngIf="messagePreview(data) as preview">— {{ preview }}</span>
                </span>
                <span class="em-row__to" *ngIf="data.toRecipients"><mat-icon>person_outline</mat-icon>{{ data.toRecipients }}</span>
              </div>
              <div class="em-row__meta">
                <span class="em-row__date">
                  {{ data.sentDate + 'Z' | date:'MMM d, y' }}
                  <small>{{ data.sentDate + 'Z' | date:'h:mm a' }}</small>
                </span>
                <ng-container *ngTemplateOutlet="emStatus; context: { $implicit: data }"></ng-container>
                <button mat-icon-button class="em-row__action is-danger" matTooltip="Delete" matTooltipClass="tooltip"
                  (click)="removeActivityEmail(data); $event.stopPropagation()" aria-label="Delete email">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </mat-expansion-panel-header>

          <div class="em-open">
            <div class="em-open__meta">
              <span><b>To</b>{{ data.toRecipients }}</span>
              <span><b>Sent</b>{{ data.sentDate + 'Z' | date:'MMM d, y · h:mm a' }}</span>
            </div>
            <div class="em-open__body">
              <app-email-body [html]="data.body"></app-email-body>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      </ng-container>
    </div>

    <ng-template #noEmails>
      <div class="em-empty">
        <span class="em-empty__icon"><mat-icon>{{ emailSearch ? 'search_off' : 'mark_email_unread' }}</mat-icon></span>
        <strong>{{ emailSearch ? 'No emails match your search' : 'No emails yet' }}</strong>
        <p>{{ emailSearch ? 'Try a different subject or recipient.' : 'Emails sent to this record will show up here.' }}</p>
        <button *ngIf="!emailSearch" mat-flat-button class="em-btn em-btn--primary" (click)="addEmailAction()">
          <mat-icon>add</mat-icon> Create Email
        </button>
      </div>
    </ng-template>
  </ng-container>

  <!-- ===== Broadcasts ===== -->
  <ng-container *ngIf="showBroadCast">
    <div class="em-list" *ngIf="filteredBroadcasts.length; else noBroadcasts">
      <ng-container *ngFor="let group of broadcastGroups; let gi = index">
      <div class="em-group">{{ group.label }}<span>{{ group.items.length }}</span></div>
      <mat-accordion multi>
        <mat-expansion-panel class="em-item" *ngFor="let data of group.items; let i = index; trackBy: trackRow"
          [expanded]="gi === 0 && i === 0">
          <mat-expansion-panel-header>
            <div class="em-row">
              <span class="em-row__icon" [class.is-sms]="data.broadCastingType == 0">
                <mat-icon>{{ data.broadCastingType == 0 ? 'textsms' : 'mail_outline' }}</mat-icon>
              </span>
              <div class="em-row__text">
                <span class="em-row__line">
                  <span class="em-row__subject">{{ data.subject }}</span>
                  <span class="em-row__preview" *ngIf="messagePreview(data, 'message') as preview">— {{ preview }}</span>
                </span>
                <span class="em-row__to"><mat-icon>{{ data.broadCastingType == 0 ? 'sms' : 'campaign' }}</mat-icon>{{ data.broadCastingType == 0 ? 'SMS broadcast' : 'Email broadcast' }}</span>
              </div>
              <div class="em-row__meta">
                <span class="em-row__date">
                  {{ data.sentDate + 'Z' | date:'MMM d, y' }}
                  <small>{{ data.sentDate + 'Z' | date:'h:mm a' }}</small>
                </span>
                <ng-container *ngTemplateOutlet="emStatus; context: { $implicit: data }"></ng-container>
                <button mat-icon-button class="em-row__action" matTooltip="Resend" matTooltipClass="tooltip"
                  (click)="resentBroadcastMessage(data); $event.stopPropagation()" aria-label="Resend broadcast">
                  <mat-icon>cached</mat-icon>
                </button>
              </div>
            </div>
          </mat-expansion-panel-header>

          <div class="em-open">
            <div class="em-open__meta">
              <span><b>Sent</b>{{ data.sentDate + 'Z' | date:'MMM d, y · h:mm a' }}</span>
            </div>
            <div class="em-open__body" [innerHTML]="data.message"></div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      </ng-container>
    </div>

    <ng-template #noBroadcasts>
      <div class="em-empty">
        <span class="em-empty__icon"><mat-icon>{{ emailSearch ? 'search_off' : 'campaign' }}</mat-icon></span>
        <strong>{{ emailSearch ? 'No broadcasts match your search' : 'No broadcasts yet' }}</strong>
        <p>{{ emailSearch ? 'Try a different subject.' : 'Email and SMS broadcasts sent to this record will show up here.' }}</p>
      </div>
    </ng-template>
  </ng-container>

</div>
